module.exports = __webpack_public_path__ + "img/max-file-search--excel.aa19036a.svg";